module.exports = __webpack_public_path__ + "media/images/services/settling-488326b700767512ba4e7d9afe295591.jpg";